import { usePublishedBoxStore } from '@/entities/sets/publish';
import { GoToPhase2Report } from '@/features/navigate';
import { Pagination } from '@/shared/ui';
import { gradingSetMap, stateSetMap } from '@/shared/utils/publish';
import { reportButtonStyles } from '@/widgets/published-box/ui/styles';
import { useEffect } from 'react';
import { useRouter } from '@tanstack/react-router';

export const ByClassStudentDetailTable = ({
    data,
    userId,
}: {
    data?: API.IntegPubSntDetailList.Res;
    userId?: string;
}) => {
    const { searchPage, setSearchPage, resetData } = usePublishedBoxStore();
    const router = useRouter();

    useEffect(() => {
        return () => {
            resetData();
        };
    }, []);

    return (
        <div className="table-board // con-mt3">
            <div className="table-board__body table-style1">
                <table>
                    <colgroup>
                        <col style={{ width: '72px' }} />
                        <col />
                        <col style={{ width: '130px' }} />
                        <col style={{ width: '104px' }} />
                        <col style={{ width: '104px' }} />
                        <col style={{ width: '140px' }} />
                    </colgroup>
                    <thead>
                        <tr>
                            <th scope="col">NO</th>
                            <th scope="col">발행한 자료</th>
                            <th scope="col">응시 기간</th>
                            <th scope="col">제출 여부</th>
                            <th scope="col">채점 상태</th>
                            <th scope="col">리포트</th>
                        </tr>
                    </thead>
                    <tbody className="align-center">
                        {data?.publishList?.map((item, idx) => {
                            const ids = userId
                                ?.split(',')
                                ?.map((s) => s.trim())
                                ?.filter(Boolean);
                            const myId = item?.claId;

                            const tail2 = (id: string) => id.split('-')?.slice(-2)?.join('-');

                            const target = tail2(myId);
                            const filtered = ids?.filter((id) => tail2(id) === target);

                            return (
                                <tr key={`detail-table-${idx}`}>
                                    <td className="txt1">{data.page.number * 10 + idx + 1}</td>
                                    <td className="row-link">
                                        <button
                                            type="button"
                                            className="link"
                                            onClick={() => {
                                                router.navigate({
                                                    to: `/sets/published-box/detail/${item.publishId}`,
                                                });
                                            }}
                                        >
                                            <span className="txt">{item.publishNm}</span>
                                            {item.sttsNm && (
                                                <span
                                                    className={`row-state ${stateSetMap[item.sttsNm]}`}
                                                >
                                                    {item.sttsNm}
                                                </span>
                                            )}
                                        </button>
                                    </td>
                                    <td
                                        className={`txt1 ${item.pdPublishStDt && item.pdPublishEdDt ? 'align-left' : ''}`}
                                    >
                                        {item.pdPublishStDt && item.pdPublishEdDt
                                            ? `${item.pdPublishStDt}~
                      ${item.pdPublishEdDt}`
                                            : '-'}
                                    </td>
                                    <td className={item.submAt == '미제출' ? 'cell-ft-color1' : ''}>
                                        {item.sttsNm === '예정'
                                            ? '예정'
                                            : item.submAt === 'Y'
                                              ? `제출 완료`
                                              : `미제출`}
                                    </td>
                                    <td
                                        className={
                                            item.mrkCpAt
                                                ? `row-grading ${gradingSetMap[item.checkStts]}`
                                                : ''
                                        }
                                    >
                                        {item.checkStts ? item.checkStts : '-'}
                                    </td>
                                    <td>
                                        {item.sttsNm === '종료' ? (
                                            <GoToPhase2Report
                                                ct="student"
                                                gubun="t"
                                                publishType={item.publishType}
                                                trgtId={item.trgtId}
                                                stntId={filtered?.[0] ?? ''}
                                                styles={reportButtonStyles}
                                                textbkId={item.textbkId}
                                            />
                                        ) : (
                                            // <GoToReport
                                            //     textbkId={item?.textbkId}
                                            //     claId={item?.claId}
                                            //     isStnts={false}
                                            //     publishType={item.publishType.toString()}
                                            //     trgtId={item.trgtId}
                                            //     stntId={userId}
                                            //     styles={reportButtonStyles}
                                            //     publishTab="클래스 학생별"
                                            // />
                                            '-'
                                        )}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
            <div className="table-board__footer">
                <Pagination
                    currentPage={searchPage}
                    totalPages={data?.page?.totalPages!}
                    onChange={(page: number) => setSearchPage(page)}
                    pageBtnCount={10}
                />
            </div>
        </div>
    );
};
